import { render, staticRenderFns } from "./MetadataPopover.vue?vue&type=template&id=08245d84&"
import script from "./MetadataPopover.vue?vue&type=script&lang=js&"
export * from "./MetadataPopover.vue?vue&type=script&lang=js&"
import style0 from "./MetadataPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08245d84')) {
      api.createRecord('08245d84', component.options)
    } else {
      api.reload('08245d84', component.options)
    }
    module.hot.accept("./MetadataPopover.vue?vue&type=template&id=08245d84&", function () {
      api.rerender('08245d84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/History/MetadataPopover.vue"
export default component.exports